import { useEffect } from 'react'

const useResizeEventListener = (callback: () => void, deps?: any) => {
  useEffect(() => {
    callback()
    window.addEventListener('resize', callback)

    return () => {
      window.removeEventListener('resize', callback)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deps])
}

export default useResizeEventListener
